<template>
  <li>
    <b-row class="single-node py-2" align-v="center">
      <b-col cols="1" class="text-center" @click="toggleChildrenVisibility" :style="pointer">
        <i 
          v-if="hasChildren"
          class="far my-1"
          :class="{ 'fa-plus-square': !showChildren, 'fa-minus-square': showChildren }"></i>
        <i v-if="!hasChildren" class="fas fa-circle my-1" style="font-size:6px;"></i>
      </b-col>
      <b-col :style="pointer" @click="toggleChildrenVisibility">
        <p class="mb-0">{{node.name}}</p>
      </b-col>
      <b-col>
      <div class="text-right">
        <button v-if="!hasChildren" class="btn btn-outline-danger btn-sm mr-3" @click="remove">
        <i class="far fa-trash-alt"></i>
        </button>
          <button class="btn btn-outline-primary btn-sm" @click="edit">
        <i class="fas fa-pencil-alt"></i>
        </button>
      </div>
      </b-col>
    </b-row>
    <div class="ml-3">
      <ul v-if="hasChildren" v-show="showChildren">
        <node v-for="(child, index) in node.children" :node="child" :key="index" @edit="$emit('edit', $event)" @remove="$emit('remove', $event)"></node>
      </ul>
    </div>
  </li>

</template>

<script>
export default {
  name: "node",
  data() {
    return { showChildren: false }
  },
  props: {
    node: Object
  },
  methods: {
    toggleChildrenVisibility() {
      if (!this.hasChildren) return;
      this.showChildren = !this.showChildren;
    },
    edit() {
      this.$emit('edit', this.node);
    },
    remove() {
      this.$emit('remove', this.node);
    }
  },
  computed:{
    hasChildren() {
      return this.node.children && this.node.children.length;
    },
    pointer() {
      return {
        cursor: this.hasChildren ? 'pointer' : 'default'
      }
    }
  }
};
</script>
<style>
  .single-node:hover {
    background: #e5f3ff;
  }
</style>